import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { M_FLOW_HEX, L_FLOW_HEX } from '../../../constants';
export const CAT_REFORMING_RR_CONFIG = {
    type: ERFElement.CatReformingRRBlock,
    icon: 'CatReformingRRBlock_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Сырьё',
                    position: Position.Left,
                    style: { top: 84, left: 14, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_product_flow',
                    type: 'source',
                    name: 'Продукт',
                    position: Position.Right,
                    style: { top: 122, right: 14, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 144, left: 44, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 144, right: 14, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFCatReformingRRNode.config.js.map